// This shows the balance of a user's wallet and will pull the data needed
// to dislay.

import React, { useEffect, useState } from "react";
import LoadingContent from "../../LoadingContent.jsx";
import useIndividualWallet from "../../../functions/Firestore/useIndividualWallet.js";
import TransactionHistoryDialog from "../../../pages/MyAccountPage/Dialogs/TransactionHistoryDialog.jsx";

export default function WalletBalance({
  communityWallet,
  setCommunityWallet,
  userId,
  firstName,
  lastName,
  balance,
  setBalance,
}) {
  const [loading, setLoading] = useState(true);

  // Makes a call to the database to load the balance.
  const error = useIndividualWallet(
    userId,
    firstName,
    lastName,
    setCommunityWallet,
    setLoading,
  );

  // Update balance whenever communityWallet changes
  useEffect(() => {
    // Sometimes the wallet doesn't have setbalance set so it needs
    // to check if that is th case otherwise just skip it.
    if (typeof setBalance === "function") {
      if (communityWallet?.Total) {
        setBalance(communityWallet.Total);
      } else {
        setBalance(0.0);
      }
    }
  }, [communityWallet]);

  // While loading the balance.
  if (loading) {
    return (
      <div>
        <LoadingContent inline={true} />
      </div>
    );
  }
  // Once it is loaded.

  // If there was an error display the error.
  if (error) {
    return (
      <div>
        <p>
          No wallet to display. Please contact
          anthony@farmtoplatemarketplace.com
        </p>
      </div>
    );
  }
  // Shows the balance of the wallet.
  return (
    <div>
      <h4>F2PM Wallet</h4>
      <table border="1">
        <thead>
          <tr>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <TransactionHistoryDialog
                buttonSize="large"
                balance={balance}
                transactionHistory={communityWallet?.transactionHistory || []}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
